(function () {
  const isMobile = window.matchMedia("(max-width: 749px)").matches;

  function cleanFacetText(text = "") {
    return text
      .replace(/\(\d+\)/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function trackFilterEvent(eventName, filterData) {
    if (!window.dataLayer) return;

    // User Requirement: "Suppress extra page_view on filter click"
    // We can't easily suppress a page_view that might be triggered by another script or page reload,
    // but we can ensure *this* event is distinct.

    // User Requirement: Track 'filter_used' event
    // with parameters: filter_type, filter_value, collection_name

    // Mapping existing logic to new requirements if event is filter-related
    if (eventName === 'filter_applied' || eventName === 'filter_removed') {
      window.dataLayer.push({
        event: 'filter_used',
        filter_type: filterData.filter_group,
        filter_value: filterData.filter_label || filterData.value, // Handle text or range value
        collection_name: window.collectionTitle || '',
        action: eventName === 'filter_applied' ? 'add' : 'remove', // Keep action for context
        device: filterData.device
      });
    } else {
      // Fallback for other events like open/close mobile which might be useful to keep or ignore based on strict requirement
      window.dataLayer.push({
        event: eventName,
        filterData: filterData // Keep original structure for non-filter_used events
      });
    }
  }

  /* =====================================================
     APLICAR / REMOVER CHECKBOX (ROBUSTO)
     ===================================================== */
  document.addEventListener(
    "change",
    function (e) {
      const target = e.target;

      if (!target.matches(".facet-checkbox input[type='checkbox']") && !target.matches(".mobile-facets__label input[type='checkbox']")) return;

      const labelEl = target.closest("label");
      const detailsEl = target.closest("details");

      const rawLabel =
        labelEl?.querySelector("span[aria-hidden='true']")?.textContent || "";
      const rawGroup =
        detailsEl?.querySelector("summary > div > span")?.childNodes[0]
          ?.textContent || "";

      trackFilterEvent(target.checked ? "filter_applied" : "filter_removed", {
        device: isMobile ? "mobile" : "desktop",
        filter_group: cleanFacetText(rawGroup) || "unknown",
        filter_label: cleanFacetText(rawLabel) || "unknown"
      });
    },
    true // ⬅️ CAPTURA TEMPRANA (CRÍTICO)
  );

  /* =====================================================
     REMOVER FILTRO DESDE PILLS
     ===================================================== */
  document.addEventListener(
    "click",
    function (e) {
      const link = e.target.closest("facet-remove a");
      if (!link) return;

      const text = cleanFacetText(
        link.textContent.replace("Remove filter", "")
      );

      let filterGroup = "unknown";
      let filterLabel = text;

      if (text.includes(":")) {
        const parts = text.split(":");
        filterGroup = parts[0].trim();
        filterLabel = parts.slice(1).join(":").trim();
      }

      trackFilterEvent("filter_removed", {
        device: isMobile ? "mobile" : "desktop",
        filter_group: filterGroup,
        filter_label: filterLabel
      });
    },
    true
  );

  /* =====================================================
     PRICE RANGE
     ===================================================== */
  document.addEventListener(
    "change",
    function (e) {
      if (!e.target.closest("price-range input")) return;

      const detailsEl = e.target.closest("details");
      const rawGroup =
        detailsEl?.querySelector("summary > div > span")?.childNodes[0]
          ?.textContent || "";

      trackFilterEvent("filter_applied", {
        device: isMobile ? "mobile" : "desktop",
        filter_group: cleanFacetText(rawGroup) || "Price",
        price_type: e.target.id.includes("GTE") ? "min" : "max",
        value: e.target.value
      });
    },
    true
  );

  /* =====================================================
     MOBILE OPEN / CLOSE FILTER DRAWER
     ===================================================== */
  /* let lastMobileState = null;

  if (isMobile) {
    document.addEventListener("toggle", function (e) {
      const details = e.target;

      if (!details.classList.contains("mobile-facets__disclosure")) return;

      if (details.open === lastMobileState) return;

      lastMobileState = details.open;

      // This is not 'filter_used' but 'filter_ui_interaction' maybe?
      // Keeping it as is but it will go to 'else' block in trackFilterEvent
      trackFilterEvent(details.open ? "filter_open_mobile" : "filter_close_mobile", {
        device: "mobile",
        event: details.open ? "open" : "close"
      });
    }, true);
  }*/
})(); 
